<div class="checkbox-table-component">
  <div class="row">
    <div class="col">
      <h5 class="title" [ngClass]="{'required': isRequired}">{{getLabelFormTitle()}}</h5>
      <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null " [formItem]="formItem" [formId]="formId"></app-audioplayer>
    </div>
  </div>

  <form action="">
    <div class="checkbox-options" *ngFor="let option of checkboxOptions">
      <div class="content-checkbox">
        <!-- Customized checkbox by bootstrap -->
        <label class="custom-control csc-custom-control-checkbox-table">
          <input type="checkbox" [checked]="option.boolValue" (change)="changeValue(option)" [id]="option.id" class="checkbox">
          <span class="custom-control-indicator"></span>
            <span class="custom-control-description csc-font-family">
              {{getLabel(option)}}
            </span>
        </label>
      </div>
    </div>
  </form>
  <small *ngIf="!selectedOptions && isRequired" class="incorrect-field">
    This field is required.
  </small>
</div>
